import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ExpandedCorporateDetailsState {
  company_id: string;
  company_name: string;
  business_type: string;
  contact_email: string;
  contact_person_name: string;
  company_license_back: string;
  company_license_front: string;
  company_license_number: string;
  employee_id_card_number: string;
  representative_profession: string;
  company_license_expiry_date: string;
  employee_id_card_front_page: string;
}

const initialState: ExpandedCorporateDetailsState = {
  company_id: '',
  company_name: '',
  business_type: '',
  contact_email: '',
  contact_person_name: '',
  company_license_back: '',
  company_license_front: '',
  company_license_number: '',
  employee_id_card_number: '',
  representative_profession: '',
  company_license_expiry_date: '',
  employee_id_card_front_page: '',
};

const expandedCorporateDetailsSlice = createSlice({
  name: 'expandedCorporateDetails',
  initialState,
  reducers: {
    setExpandedCorporateDetails: (state, action: PayloadAction<ExpandedCorporateDetailsState>) => {
      return { ...state, ...action.payload };
    },
    updateExpandedCorporateDetails: (state, action: PayloadAction<Partial<ExpandedCorporateDetailsState>>) => {
      return { ...state, ...action.payload };
    },
    resetExpandedCorporateDetails: (state) => {
      return initialState;
    },
  },
});

export const { 
  setExpandedCorporateDetails, 
  updateExpandedCorporateDetails,
  resetExpandedCorporateDetails 
} = expandedCorporateDetailsSlice.actions;

export default expandedCorporateDetailsSlice.reducer; 